import { Toast } from '@base-ui/react/toast';
import type { ReactNode } from 'react';

export type ToastVariant = 'success' | 'error' | 'info' | 'warning';

export type ToastOptions = {
  autoClose?: number;
  toastId?: string;
};

export const toastManager = Toast.createToastManager();

const activeToastIds = new Map<string, string>();

function show(type: ToastVariant, message: ReactNode, options?: ToastOptions) {
  if (options?.toastId) {
    const existing = activeToastIds.get(options.toastId);
    if (existing) return existing;
  }

  const id = toastManager.add({
    title: message,
    type,
    timeout: options?.autoClose ?? 5000,
    priority: type === 'error' ? 'high' : 'low',
    onRemove: () => {
      if (options?.toastId) activeToastIds.delete(options.toastId);
    }
  });

  if (options?.toastId) activeToastIds.set(options.toastId, id);
  return id;
}

export const toast = Object.assign((message: ReactNode, options?: ToastOptions) => show('info', message, options), {
  success: (message: ReactNode, options?: ToastOptions) => show('success', message, options),
  error: (message: ReactNode, options?: ToastOptions) => show('error', message, options),
  info: (message: ReactNode, options?: ToastOptions) => show('info', message, options),
  warn: (message: ReactNode, options?: ToastOptions) => show('warning', message, options),
  warning: (message: ReactNode, options?: ToastOptions) => show('warning', message, options)
});
